import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '../../context/BrandingContext';
import { useSession } from '../../context/SessionContext';
import './RestaurantHeader.css';

function RestaurantHeader({ tableNumber, mode = 'dine_in' }) {
  const { t } = useTranslation();
  const { branding, loading } = useBranding();
  const { session } = useSession();
  const isDelivery = session?.orderMode === 'delivery';
  const deliveryAddress = session?.deliveryAddress;

  if (loading) {
    return (
      <div className="restaurant-header restaurant-header--loading">
        <div className="restaurant-header__skeleton" />
      </div>
    );
  }

  return (
    <div className="restaurant-header">
      <div className="restaurant-header__brand">
        {branding.logoUrl ? (
          <img
            src={branding.logoUrl}
            alt={branding.restaurantName}
            className="restaurant-header__logo"
          />
        ) : (
          <div className="restaurant-header__logo-placeholder">
            <span className="material-icons" aria-hidden="true">restaurant</span>
          </div>
        )}
        <div className="restaurant-header__info">
          <h1 className="restaurant-header__name" title={branding.restaurantName}>{branding.restaurantName}</h1>
          {branding.tagline && (
            <p className="restaurant-header__tagline">{branding.tagline}</p>
          )}
        </div>
      </div>

      <div className="restaurant-header__meta">
        {mode === 'dine_in' && tableNumber && (
          <span className="restaurant-header__table">
            <span className="material-icons" aria-hidden="true">table_restaurant</span>
            {t('orders.table')} {tableNumber}
          </span>
        )}
        {mode === 'takeaway' && !isDelivery && (
          <span className="restaurant-header__mode">
            <span className="material-icons" aria-hidden="true">shopping_bag</span>
            {t('takeaway.checkoutTitle')}
          </span>
        )}
        {isDelivery && (
          <span className="restaurant-header__mode restaurant-header__mode--delivery">
            <span className="material-icons" aria-hidden="true">delivery_dining</span>
            {deliveryAddress?.street
              ? t('deliveryAddress.deliveryTo', {
                  address: deliveryAddress.street.length > 30
                    ? deliveryAddress.street.substring(0, 30) + '...'
                    : deliveryAddress.street,
                })
              : t('modePicker.delivery.title')}
          </span>
        )}
      </div>
    </div>
  );
}

export default RestaurantHeader;
